import { Body1, Body2, Header2, SubBody1 } from '@flatsy/core/MaterialUi/Typo'
import theme from '@flatsy/core/MuiTheme/theme'
import { formatPhoneNumber } from '@flatsy/utils/Functions/format/PhoneNumber'
import React from 'react'
import { SingleAvatar } from 'src/components/SingleAvatar'
import { useApplicationBooking } from 'src/hooks/ApplicationBooking'
import i18n from '@flatsy/utils/translations'
import { AgentProps } from './Type'
import { useStyles } from './Style'

const Agent: React.FC<AgentProps> = ({ application, asset }): React.ReactElement => {
  const classes = useStyles()
  const { booking } = useApplicationBooking({ applicationId: application.id })
  const renderPhoneNumber = () => {
    if (booking) {
      return formatPhoneNumber(booking.agent.phone_number)
    }

    return (
      application &&
      application.agent &&
      application.agent.phone_number &&
      formatPhoneNumber(application?.agent?.phone_number)
    )
  }

  const renderSingleAvatar = () => {
    return booking ? (
      <SingleAvatar
        imageUrl={booking?.agent?.picture_url}
        alt={`${booking?.agent?.first_name} ${booking?.agent?.last_name}`}
      />
    ) : (
      <SingleAvatar
        imageUrl={application?.agent?.picture_url}
        alt={`${application?.agent?.first_name} ${application?.agent?.last_name}`}
      />
    )
  }

  return (
    <div className={classes.card}>
      <Header2 lowerCase>{i18n.t('your_real_estate_agent')}</Header2>
      <div className={classes.containerAvatar}>
        <div className={classes.agentAvatar}>
          <div className={classes.avatar}>{renderSingleAvatar()}</div>
          <div className={classes.agentInformation}>
            <div className={classes.agentText}>
              <Body1 className={classes.agentName}>
                {booking ? booking?.agent?.first_name : application?.agent?.first_name}
              </Body1>
              <Body2 fontColor={theme.palette.secondary.dark}>
                {i18n.t('from')} {asset?.agency_name}
              </Body2>
            </div>
            <SubBody1 className={classes.agentPhone}>{renderPhoneNumber()}</SubBody1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Agent
